import { useTranslation } from "react-i18next";

import deleteIcon from "../../../assets/images/icons/delete_white.svg";
import editIcon from "../../../assets/images/icons/edit_white.svg";
import { GeneralButton, Loader, NoResult } from "../../../components";
import { EndPoints } from "../../../Constants/endpoints";
import { useGetData } from "../../../hooks";
import { IGetTarrifResponse } from "./EditPrice";
import { formatNumberWithCommas } from "../../../utils/utils";
import { useState } from "react";
import DeletePrice from "./DeletePrice";

function Price() {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const { data, isLoading, isPending } = useGetData<IGetTarrifResponse>(
    EndPoints.GetPrice,
  );

  const isNotEditable = data?.Data?.InspectionTarrif;
  return (
    <div className="box flex h-full w-full flex-col gap-4 overflow-y-auto">
      <div className="flex items-center justify-between gap-2">
        <p className="font-bold">{t("session_price")}</p>
        {isNotEditable && (
          <div className="flex items-center justify-between gap-2">
            <GeneralButton
              color="red"
              icon={deleteIcon}
              title={t("delete_price")}
              className="!px-3 !py-2"
              onClick={openModal}
            />
            <GeneralButton
              color="yellow"
              icon={editIcon}
              title={t("edit")}
              className="!px-3 !py-2"
              route="/profile/price/edit"
            />
          </div>
        )}
      </div>
      {isPending || isLoading ? (
        <Loader />
      ) : isNotEditable ? (
        <div className="flex flex-col">
          <p className="text-sm text-body-text">
            {t("your_price_per_session")}
          </p>
          <p className="text-lg font-bold">
            {formatNumberWithCommas(Number(data?.Data?.InspectionTarrif))}
            {" " + t("s_p")}
          </p>
        </div>
      ) : (
        <div className="flex w-full flex-col items-center justify-center gap-4 rounded-lg bg-InputFieldColor py-11">
          <NoResult isWithLogo />
          <GeneralButton
            type="button"
            title={t("add_session_price")}
            route="/profile/price/edit"
          />
        </div>
      )}
      <DeletePrice isModalOpen={isModalOpen} closeModal={closeModal} />
    </div>
  );
}

export default Price;
